import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner } from '@parkhub/parkhub-ui';
import { OverviewDialog, Table } from '../../components';
import { getLots } from '../../actions/lots.action';
import { clearAllFilters } from '../../actions/filter.action';

const lotsListLabelKeys = [
  { label: 'checkbox', key: 'checkbox', sortable: false },
  { label: 'Lot / Garage', key: 'displayName', sortable: true },
  { label: 'Organizations', key: 'organizations', sortable: true },
  { label: 'multiLotEdit', key: 'multiLotEdit', sortable: false }
];

class LotsGarages extends Component {
  componentDidMount() {
    this.props.clearAllFilters();
    this.props.getLots();
  }

  render() {
    const {
      actions,
      dialogVisible,
      dialogTitle,
      dialogContent,
      lots,
      isLoading,
      filteredData,
      organizations
    } = this.props;
    const lotActions = {
      hide: actions.hide,
      show: actions.show
    };
    const lotsWithParentOrg = lots.map(x => {
      x.organizations = x.organizations ? x.organizations.map(y => {
        y.parentKey = organizations && organizations.find(x => x.childKey === y.partyKey) && organizations.find(x => x.childKey === y.partyKey).parentKey;
        return y;
      }) : [];
      return x;
    });

    const filterGuard = () => {
      if (!filteredData) {
        return false;
      } else if (filteredData && filteredData.length > 0 && 'displayName' in filteredData[0]) {
        return true;
      } else if (filteredData && filteredData.length === 0) {
        return true;
      }
    };

    return (
      <Fragment>
        <div>
          <Table
            title="Lots/Garages"
            labelKeys={lotsListLabelKeys}
            isLoading={isLoading}
            data={filterGuard() ? filteredData : lotsWithParentOrg}
            actions={lotActions}
            filteredData={filteredData ? true : false}
          />
        </div>
        <OverviewDialog
          visible={dialogVisible}
          onHide={lotActions.hide}
          data={dialogContent}
          title={dialogTitle}
        />
        <LoadingSpinner show={isLoading} delay={650} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  dialogVisible: state.wizard.visible,
  organizations: state.organizations.organizations,
  dialogContent: state.wizard.data,
  dialogTitle: state.wizard.title,
  lots: state.lots.data,
  filteredData: state.filter.lotsFilteredData,
  isLoading: (state.lots.isLoading || state.organizations.isLoading),
  lotError: state.lots.isError
});

export default connect(mapStateToProps, {
  getLots,
  clearAllFilters
})(LotsGarages);



// WEBPACK FOOTER //
// ./src/containers/LotsGarages/LotsGarages.jsx